export default __webpack_public_path__ + "static/media/csc-negative.e917af12.svg";